import controller from './schedulePublish.timePickers.controller'
import template from './schedulePublish.timePickers.template.html'

export default {
  restrict: 'E',
  replace: true,
  require: {
    ngModel: '^ngModel',
  },
  template,
  controller,
  controllerAs: 'vm',
}
